"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../utils/validations");
const MessageRef_1 = __importDefault(require("./MessageRef"));
class MessageID {
    constructor(streamId, streamPartition, timestamp, sequenceNumber, publisherId, msgChainId) {
        validations_1.validateIsNotEmptyString('streamId', streamId);
        validations_1.validateIsNotNegativeInteger('streamPartition', streamPartition);
        validations_1.validateIsNotNegativeInteger('timestamp', timestamp);
        this.streamId = streamId;
        this.streamPartition = streamPartition;
        this.timestamp = timestamp;
        this.sequenceNumber = sequenceNumber;
        this.publisherId = publisherId;
        this.msgChainId = msgChainId;
    }
    toArray() {
        return [
            this.streamId,
            this.streamPartition,
            this.timestamp,
            this.sequenceNumber,
            this.publisherId,
            this.msgChainId,
        ];
    }
    static fromArray(arr) {
        const [streamId, streamPartition, timestamp, sequenceNumber, publisherId, msgChainId,] = arr;
        return new MessageID(streamId, streamPartition, timestamp, sequenceNumber, publisherId, msgChainId);
    }
    serialize() {
        return JSON.stringify(this.toArray());
    }
    toMessageRef() {
        return new MessageRef_1.default(this.timestamp, this.sequenceNumber);
    }
}
exports.default = MessageID;
//# sourceMappingURL=MessageID.js.map